import './TopNav.css';
import { Link } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import profileImg from '../images/shivanivisencrop.jpg';
import profileImgFull from '../images/shivanivisen.jpg';

const navItems = [
    { label: 'Work', path: '/', index: 0 },
    { label: 'Blogs', path: '/blogs', index: 1 },
    { label: 'Resume', href: '/Shivani-Visen-Resume.pdf', index: 2 },
];

const TopNav = ({ activeIndex }) => {
    const [scrolled, setScrolled] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 40);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const openModal = useCallback((e) => {
        e.preventDefault();
        setModalOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setModalOpen(false);
    }, []);

    useEffect(() => {
        if (!modalOpen) return;
        const handleKey = (e) => { if (e.key === 'Escape') closeModal(); };
        document.addEventListener('keydown', handleKey);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleKey);
            document.body.style.overflow = '';
        };
    }, [modalOpen, closeModal]);

    return (
        <>
        <motion.nav
            className={`TopNav ${scrolled ? 'scrolled' : ''}`}
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 100, damping: 20, delay: 0.1 }}
        >
            <button className="wordmark" onClick={openModal} aria-label="View profile photo">
                <img src={profileImg} alt="Shivani Visen" className="wordmark-avatar" />
            </button>

            <div className="nav-links">
                {navItems.map((item) => {
                    const isActive = item.index === activeIndex;
                    const className = `nav-pill ${isActive ? 'active' : ''}`;

                    if (item.href) {
                        return (
                            <a
                                key={item.index}
                                className={className}
                                href={item.href}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {item.label}
                                {isActive && (
                                    <motion.div
                                        className="active-indicator"
                                        layoutId="nav-active"
                                        transition={{ type: 'spring', stiffness: 350, damping: 30 }}
                                    />
                                )}
                            </a>
                        );
                    }

                    return (
                        <Link
                            key={item.index}
                            className={className}
                            to={item.path}
                        >
                            {item.label}
                            {isActive && (
                                <motion.div
                                    className="active-indicator"
                                    layoutId="nav-active"
                                    transition={{ type: 'spring', stiffness: 350, damping: 30 }}
                                />
                            )}
                        </Link>
                    );
                })}
            </div>

            <a
                className="nav-cta"
                href="https://ch.linkedin.com/in/shivani-visen-82918a51"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn profile"
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
            </a>
        </motion.nav>

        <AnimatePresence>
            {modalOpen && (
                <motion.div
                    className="profile-modal-backdrop"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    onClick={closeModal}
                >
                    <motion.div
                        className="profile-modal"
                        initial={{ scale: 0.3, opacity: 0, y: -60 }}
                        animate={{ scale: 1, opacity: 1, y: 0 }}
                        exit={{ scale: 0.3, opacity: 0, y: -60 }}
                        transition={{ type: 'spring', stiffness: 260, damping: 24 }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <img src={profileImgFull} alt="Shivani Visen" className="profile-modal-img" />
                        <button className="profile-modal-close" onClick={closeModal} aria-label="Close">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </button>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
        </>
    );
};

export default TopNav;
